module.exports = __webpack_public_path__ + "static/pre-sale-icon.ef523bcc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/pre-sale-icon.png
// module id = 1335
// module chunks = 168707334958949